
class FormInputController {

    $onInit() {
        if (this.inputType === 'datetime-local' && this.ngModel !== null) {
            this.ngModel = new Date(this.ngModel);
        }
    }

    /***
     * Checks that a value supplied has a value greater than zero. sets to blank if true
     * @param newValue: the value being checked against
     * @param fieldName: the fieldname that is being checked
     */
    validateNumber(newValue, fieldName) {
        console.log('updating');
        console.log(fieldName);
        if (newValue < 0) {
            alert("Please do not enter a value less than zero.");
            // this.facilitySettings[fieldName] = null;
        }
    }

}

export default FormInputController;


// WEBPACK FOOTER //
// ./app/components/enter-virtual-data/form-input/form-input-controller.js